import { useTranslation } from 'react-i18next';
import { CopyNumberButton } from '../shared/CopyNumberButton';
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { TrendingUp, TrendingDown, DollarSign, Clock } from 'lucide-react';

const BudgetOverviewCards = ({ 
  totalRevenue, 
  totalCosts, 
  totalProfit, 
  pendingApprovalsCount,
  formatCurrency 
}) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">{t('budget.totalRevenue')}</p>
              <p className="flex flex-wrap items-center gap-x-1 text-lg lg:text-xl xl:text-2xl font-bold text-green-600"><span className="whitespace-nowrap">{formatCurrency(totalRevenue)}</span><CopyNumberButton value={totalRevenue} size="sm" testId="copy-overview-revenue" /></p>
            </div>
            <TrendingUp className="h-8 w-8 text-green-500" />
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">{t('budget.totalCosts')}</p>
              <p className="flex flex-wrap items-center gap-x-1 text-lg lg:text-xl xl:text-2xl font-bold text-red-600"><span className="whitespace-nowrap">{formatCurrency(totalCosts)}</span><CopyNumberButton value={totalCosts} size="sm" testId="copy-overview-costs" /></p>
            </div>
            <TrendingDown className="h-8 w-8 text-red-500" />
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">{t('budget.totalProfit')}</p>
              <p className={`flex flex-wrap items-center gap-x-1 text-lg lg:text-xl xl:text-2xl font-bold ${totalProfit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                <span className="whitespace-nowrap">{formatCurrency(totalProfit)}</span><CopyNumberButton value={totalProfit} size="sm" testId="copy-overview-profit" />
              </p>
            </div>
            <DollarSign className="h-8 w-8 text-blue-500" />
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">{t('budget.pendingApprovals')}</p>
              <p className="text-2xl font-bold text-orange-600">{pendingApprovalsCount}</p>
            </div>
            <Clock className="h-8 w-8 text-orange-500" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BudgetOverviewCards;
